import React, { useContext, useState } from 'react';
import Slider from '../../../components/Slider/Slider';
import MatchingSetCard from '../MatchingSetCard/MatchingSetCard';
import BreakpointContext from '../../../contexts/BreakpointContext';

const CARD_WIDTH = 148;
const CONTROLS_TOP_OFFSET = 73;

export default function MatchingSetSlider({
  sets,
  tmntData,
  handleMatchingSetClick,
  hasMemberPricingEnabled,
}) {
  const [index, setIndex] = useState(0);
  const breakpoints = useContext(BreakpointContext);
  const isMobile = breakpoints.xxsmall && !breakpoints.medium;

  const nextSlide = () => {
    setIndex(index + 1);
  };

  const prevSlide = () => {
    setIndex(index - 1);
  };

  const handleFocus = (slides, currentIndex, focusSource) => {
    if (slides[currentIndex]?.firstChild && focusSource === 'keyboard') {
      slides[currentIndex].firstChild.focus();
    }
  };

  const handleSlideChange = (slides, currentIndex, focusSource) => {
    setIndex(currentIndex);
    if (slides[currentIndex]?.firstChild && focusSource === 'keyboard') {
      slides[currentIndex].firstChild.focus();
    }
  };

  const slides = sets.map((set) => (
    <MatchingSetCard
      key={set.kicId}
      image={set.imageUrl}
      name={set.name}
      brand={set.brand}
      listPrice={set.prices.list}
      memberPrice={set.prices.member}
      onClick={(event) => handleMatchingSetClick(set, event.currentTarget)}
      tmntData={tmntData}
      setSlideIndex={index}
      onNextSlide={nextSlide}
      onPrevSlide={prevSlide}
      hasMemberPricingEnabled={hasMemberPricingEnabled}
    />
  ));

  return (
    <div>
      <Slider
        showControls={!isMobile}
        currentIndex={index}
        onFocus={handleFocus}
        onSlideChange={handleSlideChange}
        slides={slides}
        slideMagnitude={1}
        minimumSlideWidth={CARD_WIDTH}
        sliderControlOffset={CONTROLS_TOP_OFFSET}
        nextLabel={tmntData?.matchingSetCarouselNextLabel?.value}
        previousLabel={tmntData?.matchingSetCarouselPrevLabel?.value}
        label={tmntData?.matchingSetLabel?.value}
        description={tmntData?.pdpSliderAriaDescription?.value}
      />
    </div>
  );
}
